module.exports = __webpack_public_path__ + "static/media/iconDEW.f0608ca5.png";